var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataResidencyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 498 191",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data_residency_placeholder_svg__clip0_1313_28965)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 191,
    rx: 16,
    fill: "#F2F7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.998 89.68h105.396V.25c-58.183.115-105.238 40.13-105.396 89.43z",
    stroke: "#E86F00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 80.38h-96.356V0C454.852 0 498 35.98 498 80.38z",
    fill: "#FBEECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.695 191.146H0V54.912c90.393 0 163.695 60.983 163.695 136.234z",
    fill: "#FBE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.332 117.494V86.3H46.701c0 17.226 16.397 31.194 36.631 31.194z",
    fill: "#F1DD5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.698 86.442V50.088c0-20.63-21.123-37.355-47.175-37.355v73.71h47.175z",
    stroke: "#F1DD5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 77.992h-97.232c-85.22 0-154.315 50.452-154.315 112.679H498V77.991z",
    fill: "#C5DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.908 92.317h-62.965v50.137c34.769 0 62.965-22.443 62.965-50.137z",
    fill: "#E86F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.943 142.454h55.052c31.24 0 56.568 21.737 56.568 48.546h-111.62v-48.546z",
    fill: "#FBE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.95 80.53V-.593H90.506c.321 44.637 43.7 80.898 97.444 81.121z",
    stroke: "#EECEE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.42 89.929V191H67.259c0-55.812 54.235-101.071 121.161-101.071z",
    fill: "#0045CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.966 190.519v-38.515h-44.644c0 21.268 19.984 38.515 44.644 38.515z",
    fill: "#FBEECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.161 190.671v-76.066c0-20.044 19.989-36.295 44.644-36.295v112.361h-44.644z",
    fill: "#0045CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 24,
    width: 224,
    height: 144,
    rx: 72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M267 96c0 4.312-.375 8.25-.75 12h-34.688c-.374-3.75-.75-7.688-.75-12 0-4.125.376-8.063.75-12h34.688c.375 3.938.75 7.875.75 12zm28.312-12A43.11 43.11 0 01297 96c0 4.312-.562 8.25-1.688 12H272.25c.375-3.75.75-7.875.75-12s-.375-8.063-.75-12h23.062zm-1.874-6H271.5c-1.875-11.813-5.625-21.938-10.312-28.313 14.624 3.938 26.624 14.438 32.25 28.313zM265.5 78h-33.188c1.126-6.75 3-12.75 5.063-17.625 2.063-4.5 4.125-7.688 6.375-9.75C245.812 48.75 247.5 48 249 48c1.312 0 3 .75 5.062 2.625 2.25 2.063 4.313 5.25 6.376 9.75C262.5 65.25 264.375 71.25 265.5 78zm-61.125 0C210 64.125 222 53.625 236.625 49.687c-4.687 6.376-8.437 16.5-10.313 28.313h-21.937zm21.187 6c-.374 3.938-.75 7.875-.75 12s.376 8.25.75 12H202.5c-1.125-3.75-1.5-7.688-1.5-12 0-4.125.375-8.063 1.5-12h23.062zm11.813 47.812c-2.063-4.874-3.937-10.874-5.063-17.812H265.5c-1.125 6.938-3 12.938-5.062 17.812-2.063 4.5-4.126 7.688-6.376 9.75-2.062 1.876-3.75 2.438-5.25 2.438-1.312 0-3-.562-5.062-2.438-2.25-2.062-4.312-5.25-6.375-9.75zm-.75 10.688C222 138.562 210 128.062 204.375 114h21.937c1.876 12 5.626 22.125 10.313 28.5zm24.563 0c4.687-6.375 8.437-16.5 10.312-28.5h21.938c-5.626 14.062-17.626 24.562-32.25 28.5z",
    fill: "#005CE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.188 142.5c-3.938 1.125-8.063 1.5-12.376 1.5-4.124 0-8.25-.375-12.187-1.5-4.687-6.375-8.437-16.5-10.313-28.5h-21.937c-.75-1.875-1.5-3.938-1.875-6h23.062c-.374-3.75-.75-7.875-.75-12s.376-8.063.75-12H202.5c.375-2.063 1.125-3.938 1.875-6h21.937c1.876-11.813 5.626-21.938 10.313-28.313A44.473 44.473 0 01248.812 48c-1.312 0-3 .75-5.062 2.625-2.25 2.063-4.312 5.25-6.375 9.75-2.063 4.875-3.937 10.875-5.063 17.625H265.5c-1.125-6.75-3-12.75-5.062-17.625-2.063-4.5-4.126-7.688-6.376-9.75C252 48.75 250.312 48 248.812 48c4.313 0 8.438.563 12.376 1.688 4.687 6.374 8.437 16.5 10.312 28.312h21.938c.75 2.063 1.5 3.938 1.874 6H272.25c.375 3.938.75 7.875.75 12s-.375 8.25-.75 12h23.062c-.374 2.062-1.124 4.125-1.874 6H271.5c-1.875 12-5.625 22.125-10.312 28.5zM232.312 114c1.126 6.938 3 12.938 5.063 17.812 2.063 4.5 4.125 7.688 6.375 9.75 2.062 1.876 3.75 2.438 5.062 2.438 1.5 0 3.188-.562 5.25-2.438 2.25-2.062 4.313-5.25 6.376-9.75 2.062-4.874 3.937-10.874 5.062-17.812h-33.188zM267 96c0-4.125-.375-8.063-.75-12h-34.688c-.374 3.938-.75 7.875-.75 12 0 4.312.376 8.25.75 12h34.688c.375-3.75.75-7.688.75-12z",
    fill: "#005CE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data_residency_placeholder_svg__clip0_1313_28965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 191,
    rx: 16,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataResidencyPlaceholder);
export default __webpack_public_path__ + "static/media/data_residency_placeholder.007a882cff38b9d5b5eb7335b3d183c9.svg";
export { ForwardRef as ReactComponent };